const initialState = {
  counter: 1,
  shouldReload: false,
};
const kitchenReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TRIGGER_RELOAD":
      return {
        ...state,
        counter: state.counter + 1,
        shouldReload: true,
      };

    case "RESET_RELOAD":
      return {
        ...state,
        shouldReload: false,
      };

    default:
      return state;
  }
};

export default kitchenReducer;
